import React, { useState, useRef, useEffect } from 'react';
import './DropdownMenu.css';

const DropdownMenu = ({ trigger, children, className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  return (
    <div className={`dropdown-menu ${className}`} ref={dropdownRef}>
      <div onClick={toggleDropdown} className="dropdown-trigger">
        {trigger}
      </div>
      {isOpen && (
        <div className="dropdown-content">
          {React.Children.map(children, (child) => {
            // Filter out null, undefined, false, and other non-React elements
            if (!child || !React.isValidElement(child)) {
              return null;
            }
            
            return React.cloneElement(child, { onClick: (e) => {
              if (child.props.onClick) {
                child.props.onClick(e);
              }
              closeDropdown();
            }});
          })}
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;